import { WAITLIST_URL } from 'lib/constants'

export const RUANICA_NAVIGATION = [
  { anchor: '#main', text: 'Home', options: { sx: { color: 'white' } } },
  { anchor: '#about', text: 'Learn more', options: { sx: { color: 'white' } } },
  { anchor: '#storyline', text: 'Storyline', options: { sx: { color: 'white' } } },
  { anchor: WAITLIST_URL, text: 'Join waitlist', options: { variant: 'contained' } },
]
